import React from "react";
import {
  Box,
  Typography,
  Divider,
  Grid,
  useTheme,
  Button,
  makeStyles,
} from "@material-ui/core";
import KenInputField from "../../global_components/KenInputField";
import KenButton from "../../global_components/KenButton";
import { sendBulkMail, gradeWiseMail } from "../../Utils/apiServices";
import KenCard from "../../global_components/KenCard";
import SmsAndMailSelection from "../../Components/SmsAndMailSelection/index"
import CSVReader from 'react-csv-reader'
import { useTranslation } from 'react-i18next';
import KenLoader from '../../Components/KenLoader/index';
import KenSnackbar from '../../Components/KenSnackbar/index';
import { Router, useHistory } from 'react-router-dom';
import routes from '../../Utils/routes.json';
import KenSelect from '../../global_components/KenSelect/index';
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from 'draftjs-to-html';

const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
    height: "100%",
  },
  note: {
    position: "absolute",
    bottom: 8,
    width: "100%",
  },
  reactCsvInput: {
    opacity: "0",
    position: "absolute"

  },
  fileUpload: {
    float: "right"
  },
  btnUpload: {
    position: "relative",
    background: "rgba(0,0,0,0.15)",
    width: "200px"
  },
  editorBox: {
    overflow: "auto",
    height: "300px"

  },
  editorWrapper: {
    lineHeight: "1.4rem"

  },
  cancelButton: {
    marginRight: "10px"
  }
}));

export default function Index() {
  const classes = useStyles();
  const theme = useTheme();
  const { t } = useTranslation();
  const history = useHistory();

  const [loading, setLoading] = React.useState(false);

  const [mail, setMail] = React.useState('');
  const [bcc, setBcc] = React.useState();
  const [recieversTo, setRecieversTo] = React.useState();
  const [recieversBcc, setRecieversBcc] = React.useState();
  const [subject, setSubject] = React.useState('');
  const [content, setContent] = React.useState('');
  const [from, setFrom] = React.useState();
  const [selectedType, setSelectedType] = React.useState('');
  const [gradeWisePayload, setGradeWisePayload] = React.useState(null);

  const [resetFrom, setRestForm] = React.useState(true);
  const [typeValue, setTypeValues] = React.useState("");

  const [editorState, setEditorState] = React.useState(() =>
  EditorState.createEmpty()
);
  //   SnackBar
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = React.useState('success');
  const [snackbarMessage, setSnackbarMessage] = React.useState('');

  const handleMail = (e) => {
    const value = e.target.value;
    if (e.target.name === "to") {
      setMail(value);
    } else {
      setBcc(value);
    }
    const array = value.split(/,/);
    const newArray = array.map((item) => {
      return item.trim();
    });
    newArray.forEach((item, index) => {
      if (item === "") {
        newArray.splice(index, 1);
      }
    });
    if (e.target.name === "to") {
      setRecieversTo(newArray);
    } else {
      setRecieversBcc(newArray);
    }
  };

  const papaparseOptions = {
    header: true,
    dynamicTyping: true,
    skipEmptyLines: true,
    transformHeader: header => header.toLowerCase().replace(/\W/g, "_")
  };


  const sendGradeWiseMail = async () => {
    const getText = await convertDraftToHtmlAndSetContent();
    try {
      const messageBody = {
        ...gradeWisePayload,
        subject: subject,
        sectionId: '',
        emailBody: getText
      }
      if (messageBody.emailBody != '' && messageBody.subject != '' && gradeWisePayload != '') {
        setLoading(true);
        const getDetails = await gradeWiseMail({ messageBody });
        handleSnackbarOpen('success', t("messages:mail_send_successfully"))
        setMail('')
        setSubject('')
        setContent('')
        setEditorState(EditorState.createEmpty())
        history.push(`/${routes.sendMail}`);
        setRestForm(false);
        setTypeValues('')
        // window.location.reload();
      } else {
        handleSnackbarOpen('error', t("messages:error_message_for_mail"))
      }
    } catch (error) {
      setLoading(false)
      handleSnackbarOpen('error', t("messages:internal_server_error"))
    }

  };

  const convertDraftToHtmlAndSetContent = async () => {
    const textContent = await draftToHtml(convertToRaw(editorState.getCurrentContent()));
    // await setContent(textContent);
    return textContent;
  }
  const onEditorStateChange = (editorState) => {
    setEditorState(editorState);
    convertDraftToHtmlAndSetContent();
    
  }

  const handleSend = async () => {
    const getText = await convertDraftToHtmlAndSetContent();
    try {
      const emailMessage = {
        emailIds: mail,
        subject: subject,
        emailBody: getText
      }
      if (emailMessage.emailIds != '' && emailMessage.subject != '' && emailMessage.emailBody != '') {
        await setLoading(true)
        const emailDetails = await sendBulkMail({ emailMessage });
        handleSnackbarOpen('success', t("messages:mail_send_successfully"));
        setMail('');
        setEditorState(EditorState.createEmpty());
        setSubject('');
        setContent('');
        history.push(`/${routes.sendMail}`)

      } else {
        handleSnackbarOpen('error', t("messages:error_message_for_mail"));
      }
    } catch (error) {
      setLoading(false)
      handleSnackbarOpen('error', t("messages:internal_server_error"))
    }

  };

  const cancelHandler = async () => {
    setMail('');
    setEditorState(EditorState.createEmpty());
    setSubject('');
    setContent('');
    setTypeValues('')
    setRestForm(true);

  }

  const handleSnackbarOpen = (severity, message) => {
    setLoading(false);
    setOpenSnackbar(true);
    setSnackbarSeverity(severity);
    setSnackbarMessage(message);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setOpenSnackbar(false);
  };


  const handleForce = async (data, fileInfo) => {
    const emails = [];
    data.forEach(element => {
      emails.push(element.mail);
    });
    console.log("emails ::::: ", emails)
    await setMail(emails.toString());
  }

  const handleSelectType = async (value) => {
    await setSelectedType(value)
    console.log(value)
  }

  const handleGradeWiseDetails = (payload) => {
    setGradeWisePayload(payload);
  }

  const changeTypes = (e) => {
    console.log(e.target.value);
    if (e.target.value === 'institute') {
      setRestForm(true);
    }
    setTypeValues(e.target.value);
    handleSelectType(e.target.value)

  }
  let types = [
    {
      label: 'Please select type',
      value: '',
    },
    
    {
      label: 'Institute',
      value: 'institute',
    },
    {
      label: 'Custom',
      value: 'custom',
    },
  ];
  React.useEffect(() => {

  }, [selectedType, editorState, content]);

  return (
    <Box className={classes.root}>
      <KenCard>
        <Typography component="div">
          <Box fontSize={32} fontWeight="fontWeightBold">
            Send Email
          </Box>
        </Typography>
        <Divider />

        <Box mt={2} mb={2}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={4} md={4}>
              <KenSelect
                options={types}
                defaultValue={typeValue}
                value={typeValue}
                onChange={changeTypes}
                label={t('labels:select_type')}
                required
              />
            </Grid>
          </Grid>
        </Box>

        {resetFrom && (typeValue === 'institute') && <SmsAndMailSelection type={1} typeValue={typeValue} handleSelectType={handleSelectType} handleGradeWiseDetails={handleGradeWiseDetails} />}

        {selectedType === 'custom' && <Grid className={classes.fileUpload}>
          <Button
            cssClass={classes.btnUpload}>
            <CSVReader
              cssClass={classes.reactCsvInput}
              onFileLoaded={handleForce}
              parserOptions={papaparseOptions}
            />{t("labels:upload_file")}
          </Button>
        </Grid>}
        <Grid
          container
          spacing={1}
          mt={8}
          style={{ marginTop: 16, marginBottom: 16 }}
        >

          {selectedType !== 'institute' && <Grid item xs={12} sm={12} md={12}>
            <KenInputField
              label="To"
              required
              name="to"
              onChange={handleMail}
              value={mail}
            />
          </Grid>}



          <Grid item xs={12} sm={12} md={12}>
            <KenInputField
              label="Subject"
              required
              name="subject"
              onChange={(e) => setSubject(e.target.value)}
              value={subject}
            />
          </Grid>
        </Grid>
        <Box className={classes.editorBox}>

        <Editor
          editorState={editorState}
          wrapperClassName={classes.editorWrapper}
          placeholder={t("messages:Please_type_here")}
          onEditorStateChange={onEditorStateChange}
          toolbar={{
            options: ['inline', 'link','blockType', 'fontSize', 'list', 'textAlign', 'colorPicker','embedded', 'emoji','remove'],


          }}
        />

          {/* <KenInputField
            multiline={true}
            label="Content"
            required
            name="content"
            onChange={(e) => setContent(e.target.value)}
            value={content}
          /> */}
        </Box>
        <Box display="flex" justifyContent="flex-end" mt={1} mb={1}>
          <KenButton label={t('labels:cancel')} variant="secondary" onClick={cancelHandler} className={classes.cancelButton} />

          {(selectedType === 'custom' || selectedType === 'predefined') && <KenButton label={t('labels:send_Mail')} variant="primary" onClick={handleSend} />}
          {selectedType === 'institute' && <KenButton label={t('labels:send_Mail')} variant="primary" onClick={sendGradeWiseMail} />}



        </Box>
      </KenCard>
      <Typography component="div" className={classes.note}>
        <Box
          // bgcolor="primary.main"
          p={1}
          mt={2}
          ml={2}
        // color={theme.palette.KenColors.kenWhite}
        >
          Note : Seperate Email Id's using comma(",") in Recievers Email Address
        </Box>
      </Typography>
      {loading && <KenLoader />}

      <KenSnackbar
        message={snackbarMessage}
        severity={snackbarSeverity}
        autoHideDuration={4000}
        open={openSnackbar}
        handleSnackbarClose={handleSnackbarClose}
        position="Bottom-Right"
      />

    </Box>
  );
}
